<template>
  <div class="modal fade" id="add-sales-new">
    <div class="modal-dialog add-centered">
      <div class="modal-content">
        <div class="page-wrapper p-0 m-0">
          <div class="content p-0">
            <div class="modal-header border-0 custom-modal-header justify-content-between">
              <div class="page-title">
                <h4>Ajouter un Devis</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="card">
              <div class="card-body">
                <form @submit.prevent="submitForm">
                  <div class="row">
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
                          <label class="mb-0">Nom du Client</label>
                          <button
                            type="button"
                            class="btn btn-outline-primary btn-sm"
                            @click="toggleQuickClientForm"
                          >
                            {{ showQuickClientForm ? "Fermer" : "Nouveau client" }}
                          </button>
                        </div>
                        <div class="mt-2">
                          <vue-select
                            :options="clientData"
                            v-model="form.nom_client"
                            id="choosefive"
                            placeholder="Choisir"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Mode du Paiement</label>
                        <vue-select :options="PaiementMethods" v-model="form.mode_paiement" id="choosename"
                          placeholder="choose" />
                      </div>
                    </div>
                  </div>
                  <div v-if="showQuickClientForm" class="row">
                    <div class="col-lg-12 col-12">
                      <div class="border rounded p-3 mb-3 bg-light">
                        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                          <div>
                            <h6 class="mb-1">Créer un client rapide</h6>
                            <small class="text-muted">
                              Le client sera ajouté puis sélectionné automatiquement dans ce devis.
                            </small>
                          </div>
                          <span class="badge bg-secondary">Type client: CLIENT</span>
                        </div>
                        <div class="row">
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="input-blocks">
                              <label>Type</label>
                              <vue-select
                                :options="quickClientTypes"
                                v-model="quickClientForm.typeLabel"
                                placeholder="Choisir"
                              />
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="input-blocks">
                              <label>Nom</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{ 'is-invalid': !!quickClientErrors.nom }"
                                v-model="quickClientForm.nom"
                                placeholder="Nom"
                                @input="clearQuickClientError('nom')"
                              />
                              <div v-if="quickClientErrors.nom" class="invalid-feedback d-block">
                                {{ quickClientErrors.nom }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="input-blocks">
                              <label>Prénom</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{ 'is-invalid': !!quickClientErrors.prenom }"
                                v-model="quickClientForm.prenom"
                                placeholder="Prénom"
                                @input="clearQuickClientError('prenom')"
                              />
                              <div v-if="quickClientErrors.prenom" class="invalid-feedback d-block">
                                {{ quickClientErrors.prenom }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="input-blocks">
                              <label>Téléphone</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{ 'is-invalid': !!quickClientErrors.telephone }"
                                v-model="quickClientForm.telephone"
                                placeholder="Téléphone"
                                @input="clearQuickClientError('telephone')"
                              />
                              <div v-if="quickClientErrors.telephone" class="invalid-feedback d-block">
                                {{ quickClientErrors.telephone }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-sm-12 col-12">
                            <div class="input-blocks">
                              <label>Adresse</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{ 'is-invalid': !!quickClientErrors.adresse }"
                                v-model="quickClientForm.adresse"
                                placeholder="Adresse"
                                @input="clearQuickClientError('adresse')"
                              />
                              <div v-if="quickClientErrors.adresse" class="invalid-feedback d-block">
                                {{ quickClientErrors.adresse }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="input-blocks">
                              <label>Email</label>
                              <input
                                type="email"
                                class="form-control"
                                :class="{ 'is-invalid': !!quickClientErrors.email }"
                                v-model="quickClientForm.email"
                                placeholder="Email"
                                @input="clearQuickClientError('email')"
                              />
                              <div v-if="quickClientErrors.email" class="invalid-feedback d-block">
                                {{ quickClientErrors.email }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-sm-6 col-12">
                            <div class="input-blocks">
                              <label>Ville</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{ 'is-invalid': !!quickClientErrors.ville }"
                                v-model="quickClientForm.ville"
                                placeholder="Ville"
                                @input="clearQuickClientError('ville')"
                              />
                              <div v-if="quickClientErrors.ville" class="invalid-feedback d-block">
                                {{ quickClientErrors.ville }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="quickClientForm.typeLabel === 'Professionnel'" class="row">
                          <div class="col-lg-6 col-sm-6 col-12">
                            <div class="input-blocks">
                              <label>Nom de société</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{ 'is-invalid': !!quickClientErrors.nom_societe }"
                                v-model="quickClientForm.nom_societe"
                                placeholder="Nom de société"
                                @input="clearQuickClientError('nom_societe')"
                              />
                              <div v-if="quickClientErrors.nom_societe" class="invalid-feedback d-block">
                                {{ quickClientErrors.nom_societe }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-sm-6 col-12">
                            <div class="input-blocks">
                              <label>RC</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{ 'is-invalid': !!quickClientErrors.rc }"
                                v-model="quickClientForm.rc"
                                placeholder="RC"
                                @input="clearQuickClientError('rc')"
                              />
                              <div v-if="quickClientErrors.rc" class="invalid-feedback d-block">
                                {{ quickClientErrors.rc }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12 text-end">
                            <button
                              type="button"
                              class="btn btn-cancel add-cancel me-2"
                              @click="cancelQuickClientForm"
                            >
                              Annuler
                            </button>
                            <button
                              type="button"
                              class="btn btn-submit"
                              :disabled="quickClientSubmitting"
                              @click="createQuickClientAndSelect"
                            >
                              {{ quickClientSubmitting ? "Ajout..." : "Ajouter et sélectionner" }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Conditions de règlement</label>
                        <vue-select :options="Conditions" v-model="form.conditions_paiement" id="choosensamess"
                          placeholder="choose" />
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Délai de livraison </label>
                        <select v-model="form.delaiLivraision" id="choosenamessa" class="form-select">
                          <option disabled value="">Choisir</option>
                          <option v-for="delay in delaisOptions" :key="delay" :value="delay">{{ delay }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Statut du devis</label>
                        <vue-select v-model="form.statut1" :options="Completed1" id="progressssdee"
                          placeholder="Choose" />
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Type</label>
                        <div class="row">
                          <div class="col-lg-12 col-sm-10 col-10">
                            <vue-select :options="producttsType" id="dazdadzdffghddh"
                              placeholder="Ajouter un nouveau Produit / Service" v-model="selectedTypeAdd" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Nom du Produit / Service</label>
                        <div class="row">
                          <div class="col-lg-11 col-sm-10 col-10">
                            <vue-select :options="itemsList" id="dazdadzdffghh"
                              placeholder="Ajouter un nouveau Produit / Service" v-model="form.selectedProduct" />
                          </div>
                          <div class="col-lg-1 col-sm-2 col-2 ps-0">
                            <div class="add-icon">
                              <a href="javascript:void(0);" class="choose-add"
                                v-on:click="addProduct(selectedProducts, form)">
                                <vue-feather type="plus-circle" class="plus"></vue-feather>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isCommandeLinesLoading" class="text-center my-4">
                    <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
                  </div>
                  <div class="table-responsive no-pagination" v-show="!isCommandeLinesLoading">
                    <table class="table datanew">
                      <thead>
                        <tr>
                          <th>Produit / Service</th>
                          <th>Type</th>
                          <th>Prix Unitaire</th>
                          <th>Quantité</th>
                          <th>Réduc (%)</th>
                          <th>Prix HT</th>
                          <th>TVA</th>
                          <th>Prix TTC</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, index) in selectedProducts" :key="index">
                          <td v-if="product.item_id !== null">
                            <div class="productimgname">
                              <a href="javascript:void(0);">{{ product.nom }}</a>
                            </div>
                          </td>
                          <td v-else>
                            <div class="productimgname align-items-center">
                              <div class="input-blocks">
                                <div class="input-group select-code">
                                  <input type="text" placeholder="0" v-model="selectedProducts[index].nom" />
                                </div>
                              </div>
                            </div>
                          </td>
                          <td v-if="product.item_id !== null">{{ product.item_type }}</td>
                          <td v-else>
                            <vue-select :options="producttsType" v-model="selectedProducts[index].item_type" />

                          </td>
                          <td v-if="product.item_id !== null">{{ product.prix_unitaire }}</td>
                          <td v-else>
                            <div class="input-blocks">
                              <div class="input-group">
                                <input type="number" min="0" class="form-control" placeholder="0"
                                  @input="changePrice(index, selectedProducts, form)"
                                  v-model="selectedProducts[index].prix_unitaire" />
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="product-quantity">
                              <span class="quantity-btn" v-on:click="increaseQuantity(index, selectedProducts, form)">
                                +<vue-feather type="plus-circle" class="plus-circle"></vue-feather>
                              </span>
                              <input type="text" class="quntity-input" v-model="product.quantite" disabled />
                              <span class="quantity-btn" v-on:click="decreaseQuantity(index, selectedProducts, form)">
                                <vue-feather type="minus-circle" class="search"></vue-feather>
                              </span>
                            </div>
                          </td>
                          <td>
                            <div class="input-blocks">
                              <div class="input-group">
                                <input type="number" min="0" max="100" step="0.01" class="form-control" placeholder="0"
                                  v-model.number="selectedProducts[index].reduc"
                                  @input="changePrice(index, selectedProducts, form)" />
                              </div>
                            </div>
                          </td>
                          <td>{{ product.montant_HT.toFixed ? product.montant_HT.toFixed(2) : product.montant_HT }}</td>
                          <td v-if="product.item_id !== null">{{ product.tax }}</td>
                          <td v-else>
                            <div class="input-blocks">
                              <div class="input-group">
                                <input type="number" min="0" step="0.01" class="form-control"
                                  v-model.number="selectedProducts[index].tax"
                                  @input="changePrice(index, selectedProducts, form)" />
                              </div>
                            </div>
                          </td>
                          <td>{{ product.montant_TTC }}</td>
                          <td>
                            <a class="confirm-text p-2"
                              @click="deleteProduct(index, selectedProducts, form, deletedProducts)"
                              href="javascript:void(0);">
                              <vue-feather type="trash-2" class="trash-2"></vue-feather>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 ms-auto">
                      <div class="total-order w-100 max-widthauto m-auto mb-4">
                        <ul>
                          <li>
                            <h4>Totale HT</h4>
                            <h5>{{ Number(form.montant_HT).toFixed(2) }}</h5>
                          </li>
                          <li>
                            <h4>TVA</h4>
                            <h5>{{ Number(form.montant_TTC - form.montant_HT).toFixed(2) }}</h5>
                          </li>
                          <li>
                            <h4>Totale TTC</h4>
                            <h5>{{ Number(form.montant_TTC).toFixed(2) }}</h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="input-blocks">
                        <label>Notes</label>
                        <textarea class="form-control" v-model="form.notes"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 text-end">
                      <button type="button" class="btn btn-cancel add-cancel me-3"
                        data-bs-dismiss="modal">Annuler</button>
                      <button type="submit" class="btn btn-submit add-sale">Ajouter</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /add popup -->

  <!-- edit popup -->
  <div v-show="editModalOpen" id="edit-sales-new" class="devis-edit-overlay" role="dialog" aria-modal="true">
    <div class="modal-dialog edit-sales-modal devis-edit-dialog">
      <div class="modal-content">
        <div class="page-wrapper p-0 m-0">
          <div class="content p-0">
            <div class="page-header p-4 mb-0">
              <div class="add-item new-sale-items d-flex">
                <div class="page-title">
                  <h4>Modifier le Devis</h4>
                </div>
                <button type="button" class="close" aria-label="Close" @click="closeEditModal">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <form @submit.prevent="submitForm1">
                  <div class="row">
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Nom du Client</label>
                        <div class="row">
                          <div class="col-lg-12 col-sm-12 col-12">
                            <select v-model="form1.nom_client" id="choosefivei" class="form-select">
                              <option disabled value="">Choisir un client</option>
                              <option v-for="client in clientData" :key="client" :value="client">{{ client }}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Mode du Paiement</label>
                        <select v-model="form1.mode_paiement" id="choosenamejj" class="form-select">
                          <option disabled value="">Choisir</option>
                          <option v-for="method in PaiementMethods" :key="method" :value="method">{{ method }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Conditions de règlement</label>
                        <select v-model="form1.conditions_paiement" id="choosensamessii" class="form-select">
                          <option disabled value="">Choisir</option>
                          <option v-for="condition in Conditions" :key="condition" :value="condition">{{ condition }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Délai de livraison </label>
                        <select v-model="form1.delaiLivraision" id="choosenamessaff" class="form-select"
                          @change="markEditDeliveryChanged">
                          <option disabled value="">Choisir</option>
                          <option v-for="delay in delaisOptions" :key="delay" :value="delay">{{ delay }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Statut du devis</label>
                        <select v-model="form1.statut1" id="progressssdeeplpl" class="form-select">
                          <option v-for="status in Completed1" :key="status" :value="status">{{ status }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Type</label>
                        <div class="col-lg-12 col-sm-12 col-12">
                          <select v-model="selectedTypeEdit" id="dazdadzdffghddhtyt" class="form-select"
                            @change="updateEditItemsList">
                            <option v-for="type in producttsType" :key="type" :value="type">{{ type }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Nom du Produit / Service</label>
                        <div class="row">
                          <div class="col-lg-11 col-sm-10 col-10">
                            <select v-model="form1.selectedProduct" id="dazdadzdffghddhaa" class="form-select">
                              <option disabled value="">Ajouter un produit ou service</option>
                              <option v-for="item in editItemsList" :key="item" :value="item">{{ item }}</option>
                            </select>
                          </div>
                          <div class="col-lg-1 col-sm-2 col-2 ps-0">
                            <div class="add-icon">
                              <a href="javascript:void(0);" class="choose-add"
                                v-on:click="addProduct(selectedProducts1, form1)">
                                <vue-feather type="plus-circle" class="plus"></vue-feather>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isCommandeLinesLoading" class="text-center my-4">
                    <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
                  </div>
                  <div class="table-responsive no-pagination" v-show="!isCommandeLinesLoading">
                    <table class="table datanew">
                      <thead>
                        <tr>
                          <th>Produit / Service</th>
                          <th>Type</th>
                          <th>Prix Unitaire</th>
                          <th>Quantité</th>
                          <th>Réduc (%)</th>
                          <th>Prix HT</th>
                          <th>TVA</th>
                          <th>Prix TTC</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, index) in selectedProducts1" :key="index">
                          <td v-if="product.item_id !== null">
                            <div class="productimgname">
                              <a href="javascript:void(0);">{{ product.nom }}</a>
                            </div>
                          </td>
                          <td v-else>
                            <div class="productimgname align-items-center">
                              <div class="input-blocks">
                                <div class="input-group select-code">
                                  <input type="text" placeholder="0" v-model="selectedProducts1[index].nom" />
                                </div>
                              </div>
                            </div>
                          </td>
                          <td v-if="product.item_id !== null">{{ product.item_type }}</td>
                          <td v-else>
                            <select v-model="selectedProducts1[index].item_type" class="form-select">
                              <option v-for="type in producttsType" :key="type" :value="type">{{ type }}</option>
                            </select>
                          </td>
                          <td v-if="product.item_id !== null">{{ product.prix_unitaire }}</td>
                          <td v-else>
                            <div class="input-blocks">
                              <div class="input-group">
                                <input type="number" min="0" class="form-control" placeholder="0"
                                  @input="changePrice(index, selectedProducts1, form1)"
                                  v-model="selectedProducts1[index].prix_unitaire" />
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="product-quantity">
                              <span class="quantity-btn" v-on:click="increaseQuantity(index, selectedProducts1, form1)">
                                +<vue-feather type="plus-circle" class="plus-circle"></vue-feather>
                              </span>
                              <input type="text" class="quntity-input" v-model="product.quantite" disabled />
                              <span class="quantity-btn" v-on:click="decreaseQuantity(index, selectedProducts1, form1)">
                                <vue-feather type="minus-circle" class="search"></vue-feather>
                              </span>
                            </div>
                          </td>
                          <td>
                            <div class="input-blocks">
                              <div class="input-group">
                                <input type="number" min="0" max="100" step="0.01" class="form-control" placeholder="0"
                                  v-model.number="selectedProducts1[index].reduc"
                                  @input="changePrice(index, selectedProducts1, form1)" />
                              </div>
                            </div>
                          </td>
                          <td>{{ product.montant_HT.toFixed ? product.montant_HT.toFixed(2) : product.montant_HT }}</td>
                          <td v-if="product.item_id !== null">{{ product.tax }}</td>
                          <td v-else>
                            <div class="input-blocks">
                              <div class="input-group">
                                <input type="number" min="0" step="0.01" class="form-control"
                                  v-model.number="selectedProducts1[index].tax"
                                  @input="changePrice(index, selectedProducts1, form1)" />
                              </div>
                            </div>
                          </td>
                          <td>{{ product.montant_TTC }}</td>
                          <td>
                            <a class="confirm-text p-2"
                              @click="deleteProduct(index, selectedProducts1, form1, deletedProducts1)"
                              href="javascript:void(0);">
                              <vue-feather type="trash-2" class="trash-2"></vue-feather>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 ms-auto">
                      <div class="total-order w-100 max-widthauto m-auto mb-4">
                        <ul>
                          <li>
                            <h4>Totale HT</h4>
                            <h5>{{ form1.montant_HT ? Number(form1.montant_HT).toFixed(2) : 0 }}</h5>
                          </li>
                          <li>
                            <h4>TVA</h4>
                            <h5>{{ form1.montant_HT ? Number(form1.montant_TTC - form1.montant_HT).toFixed(2) : 0 }}
                            </h5>
                          </li>
                          <li>
                            <h4>Totale TTC</h4>
                            <h5>{{ form1.montant_TTC ? Number(form1.montant_TTC).toFixed(2) : 0 }}</h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="input-blocks">
                        <label>Notes</label>
                        <textarea class="form-control" v-model="form1.notes"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 text-end">
                      <button type="button" class="btn btn-cancel add-cancel me-3"
                        @click="closeEditModal">Annuler</button>
                      <button type="submit" class="btn btn-submit add-sale">Modifier</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Read-only devis details popup -->
  <div class="modal fade" id="sales-details-new" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <div>
            <h4 class="modal-title">Détail du devis</h4>
            <p class="mb-0 text-muted">{{ data.numero_devis || "—" }}</p>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
        </div>
        <div class="modal-body p-4">
          <div class="row g-3 mb-4">
            <div class="col-md-6 col-lg-3">
              <div class="border rounded p-3 h-100">
                <small class="text-muted d-block mb-2">Client</small>
                <strong>{{ data.client_nom || "—" }}</strong>
                <div v-if="data.client_nom_societe" class="text-muted mt-1">{{ data.client_nom_societe }}</div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="border rounded p-3 h-100">
                <small class="text-muted d-block mb-2">Date de création</small>
                <strong>{{ formatDisplayDate(data.date_creation) }}</strong>
                <div class="text-muted mt-1">Valide jusqu'au {{ formatDisplayDate(data.valide_jusqua) }}</div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="border rounded p-3 h-100">
                <small class="text-muted d-block mb-2">Statut</small>
                <span class="badge bg-success">{{ data.statut || "—" }}</span>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="border rounded p-3 h-100">
                <small class="text-muted d-block mb-2">Total TTC</small>
                <strong class="fs-5">{{ formatDh(data.montant_total) }}</strong>
              </div>
            </div>
          </div>

          <h5 class="mb-3">Produits et services</h5>
          <div class="table-responsive">
            <table class="table align-middle">
              <thead>
                <tr>
                  <th>Désignation</th>
                  <th>Type</th>
                  <th class="text-center">Quantité</th>
                  <th class="text-end">Prix unitaire HT</th>
                  <th class="text-end">Réduction</th>
                  <th class="text-end">Total HT</th>
                  <th class="text-end">Total TTC</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="data.view_lines_loading" key="devis-lines-loading">
                  <td colspan="7" class="text-center py-4">Chargement...</td>
                </tr>
                <tr v-for="(line, index) in data.view_lines" :key="line.id || `devis-line-${index}`">
                  <td>{{ line.item_data?.nom || line.nom_libre || "—" }}</td>
                  <td>{{ line.item_type === "product" ? "Produit" : "Service" }}</td>
                  <td class="text-center">{{ line.quantite }}</td>
                  <td class="text-end">{{ formatDh(line.prix_unitaire) }}</td>
                  <td class="text-end">{{ formatDh(line.reduction) }}</td>
                  <td class="text-end">{{ formatDh(line.montant_HT) }}</td>
                  <td class="text-end fw-semibold">{{ formatDh(line.montant_TTC) }}</td>
                </tr>
                <tr v-if="!data.view_lines_loading && (!data.view_lines || !data.view_lines.length)"
                  key="devis-lines-empty">
                  <td colspan="7" class="text-center text-muted py-4">Aucun produit ou service.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row justify-content-end mt-3">
            <div class="col-md-5 col-lg-4">
              <div class="border rounded p-3">
                <div class="d-flex justify-content-between mb-2">
                  <span>Total HT</span><strong>{{ formatDh(viewTotalHt(data.view_lines)) }}</strong>
                </div>
                <div class="d-flex justify-content-between pt-2 border-top fs-5">
                  <span>Total TTC</span><strong>{{ formatDh(data.montant_total) }}</strong>
                </div>
              </div>
            </div>
          </div>
          <div v-if="data.notes" class="mt-4">
            <h6>Notes</h6>
            <p class="mb-0 text-muted">{{ data.notes }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
  <!-- /details popup -->



  <!-- show payment Modal -->
  <div class="modal fade" id="showpayment" tabindex="-1" aria-labelledby="showpayment" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered stock-adjust-modal">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header">
              <div class="page-title">
                <h4>Show Payments</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <div class="row">
                <div class="col-lg-12">
                  <div class="modal-body-table total-orders">
                    <div class="table-responsive">
                      <table class="table datanew">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Reference</th>
                            <th>Amount</th>
                            <th>Paid By</th>
                            <th class="no-sort">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0101</td>
                            <td>$1500</td>
                            <td>Cash</td>
                            <td class="action-table-data">
                              <div class="edit-delete-action">
                                <a class="me-3 p-2" href="javascript:void(0);">
                                  <vue-feather type="printer" class="printer"></vue-feather>
                                </a>
                                <a class="me-3 p-2" href="javascript:void(0);" data-bs-toggle="modal"
                                  data-bs-target="#editpayment">
                                  <vue-feather type="edit" class="feather-edit"></vue-feather>
                                </a>
                                <a class="confirm-text p-2" href="javascript:void(0);" @click="showConfirmation">
                                  <vue-feather type="trash-2" class="feather-trash-2"></vue-feather>
                                </a>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- show payment Modal -->

  <!-- Create payment Modal -->
  <div class="modal fade" id="createpayment" tabindex="-1" aria-labelledby="createpayment" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 custom-modal-header">
          <div class="page-title">
            <h4>Create Payments</h4>
          </div>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body custom-modal-body">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-lg-6">
                <div class="input-blocks">
                  <label> Date</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="calendar" class="info-img"></vue-feather>
                    <input type="text" class="datetimepicker" placeholder="Choose Date" />
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Reference</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Received Amount</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="dollar-sign" class="info-img"></vue-feather>
                    <input type="text" />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Paying Amount</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="dollar-sign" class="info-img"></vue-feather>
                    <input type="text" />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Payment type</label>
                  <vue-select :options="OnlineOne" id="online01" placeholder="Choose" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="input-blocks">
                  <label>Description</label>
                  <textarea class="form-control"></textarea>
                  <p>Maximum 60 Characters</p>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="modal-footer-btn">
                <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button type="submit" class="btn btn-submit">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Create payment Modal -->

  <!-- edit payment Modal -->
  <div class="modal fade" id="editpayment" tabindex="-1" aria-labelledby="editpayment" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 custom-modal-header">
          <div class="page-title">
            <h4>Edit Payments</h4>
          </div>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body custom-modal-body">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-lg-6">
                <div class="input-blocks">
                  <label>19 Jan 2023</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="calendar" class="info-img"></vue-feather>
                    <input type="text" class="datetimepicker form-control" placeholder="Select Date" />
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Reference</label>
                  <input type="text" value="INV/SL0101" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Received Amount</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="dollar-sign" class="info-img"></vue-feather>
                    <input type="text" value="1500" />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Paying Amount</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="dollar-sign" class="info-img"></vue-feather>
                    <input type="text" value="1500" />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Payment type</label>
                  <vue-select :options="Online" id="cash" placeholder="Cash" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="input-blocks summer-description-box transfer">
                  <label>Description</label>
                  <textarea class="form-control"></textarea>
                </div>
                <p>Maximum 60 Characters</p>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="modal-footer-btn mb-3 me-3">
                <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button type="submit" class="btn btn-submit">
                  Save Changes
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- edit payment Modal -->
</template>

<script>
import { createClient, getClientsData } from "@/services/clientsService";
import { getProductsDataInStock, getServicesData } from "@/services/productsService";
import { Modal } from "bootstrap";
import { decodeToken } from "@/services/jwtService";
import { getLignesCommandeDataByCommandeId } from "@/services/devisService";
import {
  createCommand,
  createCommandLine,
  createDevis,
  updateCommand,
  updateCommandLine,
  updateDevis,
  deleteCommandLine,
} from "@/services/devisService";

import Swal from "sweetalert2";
import { ref } from "vue";
import { toast } from "vue3-toastify";
const currentDate = ref(new Date());
const clientData = [];
const clientIds = [];
const productsData = [];
const productsIds = [];
const selectedProducts = [];
const selectedProducts1 = [];
const deletedProducts = [];
const deletedProducts1 = [];
const insertedProducts = [];
const itemsList = [];

const commandeLinesCache = new Map();
const COMMAND_LINES_CACHE_TTL_MS = 5000;
let activeCommandeLinesFetch = null;
let activeCommandeLinesId = null;
const getEmptyQuickClientForm = () => ({
  typeLabel: "Particulié",
  nom: "",
  prenom: "",
  telephone: "",
  adresse: "",
  email: "",
  ville: "",
  pays: "Maroc",
  civilite: "",
  nom_societe: "",
  rc: "",
  ice: "",
  tp: "",
  identifiant_fiscal: "",
  informations_complementaires: "",
  plafond_credit: null,
  delai_paiement: null,
});

export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    selectionMode: {
      type: String,
      required: false,
      default: null,
    },
  },
  formatSQLDate(value) {
    try {
      const d = value instanceof Date ? value : new Date(value);
      if (isNaN(d)) return null;
      return d.toISOString().slice(0, 19).replace("T", " ");
    } catch (_) {
      return null;
    }
  },
  data() {
    return {
      form: {
        nom_client: "",
        selectedProduct: "",
        montant_HT: 0,
        montant_TTC: 0,
        date_creation: currentDate,
        statut: "TERMINEE",
        mode_paiement: "",
        conditions_paiement: "",
        date_livraison: currentDate,
        delaiLivraision: "Immédiate (0 jour)",
        client_id: null,
        montant_total: 0,
        montant_taxe: 0,
        numero_commande: "",
        notes: "",
        cree_par: null,
        societe_id: null,
        numero_devis: "",
        statut1: "",
      },
      form1: {
        nom_client: "",
        selectedProduct: "",
        montant_HT: 0,
        montant_TTC: 0,
        date_creation: currentDate,
        statut: "TERMINEE",
        mode_paiement: "",
        conditions_paiement: "",
        date_livraison: currentDate,
        client_id: null,
        montant_total: 0,
        montant_taxe: 0,
        numero_commande: "",
        notes: "",
        cree_par: 2,
        societe_id: 1,
        numero_devis: "",
        statut1: "",
        delaiLivraision: "Immédiate (0 jour)",
        commande_id: null,
      },
      Choose: ["Choose", "Customer Name"],
      Choosename: ["Choose", "Supplier Name"],
      Completed: ["ANNULEE", "TERMINEE", "EN_ATTENTE", "EN_COURS", "EXPEDIEE"],
      Completed1: ["BROUILLON", "VALIDÉ", "ANNULÉ"],
      Types: ["PRODUIT", "SERVICE"],
      Thomas: ["Thomas", "Name"],
      Shoes: ["Dazzle Shoes", "Supplier Name"],
      Online: ["Choose", "Online", "Cash"],
      OnlineOne: ["Choose", "Online", "Cash"],
      PaiementMethods: [
        "Carte Bancaire",
        "Chèque",
        "Espèce",
        "Ordre de Prélèvement",
        "Virement Bancaire",
      ],
      Conditions: [
        "A réception",
        "10 jours",
        "10 jours fin de mois",
        "14 jours",
        "14 jours fin de mois",
        "30 jours",
        "30 jours fin de mois",
        "60 jours",
        "60 jours fin de mois",
        "A commande",
        "A Livraison",
        "50/50",
      ],
      delaisOptions: [
        "Immédiate (0 jour)",
        "1 jour",
        "2 jours",
        "3 jours",
        "4 jours",
        "5 jours",
        "1 semaine (7 jours)",
        "2 semaines (14 jours)",
        "3 semaines (21 jours)",
        "4 semaines (28 jours)",
        "5 semaines (35 jours)",
        "6 semaines (42 jours)",
        "8 semaines (56 jours)",
        "10 semaines (70 jours)",
        "12 semaines (84 jours)",
        "14 semaines (98 jours)",
        "16 semaines (112 jours)",
      ],
      producttsType: ["PRODUIT", "SERVICE"],
      selectedTypeAdd: "PRODUIT",
      selectedTypeEdit: "PRODUIT",
      quickClientTypes: ["Particulié", "Professionnel"],
      showQuickClientForm: false,
      quickClientSubmitting: false,
      quickClientForm: getEmptyQuickClientForm(),
      quickClientErrors: {},

      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      clientData,
      clientIds,
      productsData,
      productsIds,
      selectedProducts,
      selectedProducts1,
      deletedProducts,
      deletedProducts1,
      insertedProducts,
      itemsList,
      editItemsList: [],
      isCommandeLinesLoading: false,
      editModalOpen: false,
    };
  },
  methods: {
    async openEdit(newData) {
      await this.prepareEdit(newData);
      this.editModalOpen = true;
      try {
        await this.loadCommandeLines(this.form1.commande_id);
      } catch (error) {
        console.warn("Failed to load commande lines:", error);
      }
    },
    closeEditModal() {
      this.editModalOpen = false;
    },
    updateEditItemsList() {
      const type = this.selectedTypeEdit === "PRODUIT" ? "product" : "service";
      this.editItemsList = this.productsIds
        .filter((item) => item.item_type === type)
        .map((item) => item.nom);
    },
    markEditDeliveryChanged() {
      this._editDeliveryChanged = true;
    },
    async prepareEdit(newData) {
      if (!newData) return;
      this.form1.devis_id = newData.id;
      this.form1.nom_client = this.getClientName(newData.client_id);
      this.form1.montant_HT = newData.montant_taxe;
      this.form1.montant_TTC = newData.montant_total;
      this.form1.mode_paiement = newData.mode_paiement;
      this.form1.client_id = newData.client_id;
      this.form1.notes = newData.notes;
      this.form1.societe_id = newData.societe_id;
      this.form1.numero_devis = newData.numero_devis;
      this.form1.statut1 = newData.statut;
      this.form1.commande_id = newData.commande_id;
      this.updateEditItemsList();

      this._editCommandeSnapshot = newData.commande
        ? { ...newData.commande }
        : {};
      this._editDeliveryChanged = false;

    },
    formatDh(value) {
      const amount = Number(value ?? 0);
      return `${new Intl.NumberFormat("fr-MA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number.isFinite(amount) ? amount : 0)} DH`;
    },
    formatDisplayDate(value) {
      if (!value) return "—";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "—";
      return new Intl.DateTimeFormat("fr-MA", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(date);
    },
    viewTotalHt(lines) {
      if (!Array.isArray(lines)) return 0;
      return lines.reduce((total, line) => total + Number(line.montant_HT || 0), 0);
    },
    normalizeConditionLabel(value) {
      return String(value ?? "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();
    },
    resolveDevisValidityDate(dateValue, conditionValue) {
      const condition = this.normalizeConditionLabel(conditionValue);
      if (!condition) {
        return null;
      }

      const date = dateValue ? new Date(dateValue) : new Date();
      if (Number.isNaN(date.getTime())) {
        return null;
      }

      if (
        condition.includes("a reception") ||
        condition.includes("a commande") ||
        condition.includes("a livraison") ||
        condition.includes("50/50")
      ) {
        return this.formatSQLDate(date);
      }

      const match = condition.match(/(\d+)\s*jours?/);
      if (!match) {
        return null;
      }

      date.setDate(date.getDate() + Number(match[1]));

      if (condition.includes("fin de mois")) {
        date.setMonth(date.getMonth() + 1, 0);
      }

      return this.formatSQLDate(date);
    },
    getClientDisplayName(client) {
      const societeName = String(client?.nom_societe ?? "").trim();
      if (societeName) {
        return societeName;
      }

      return [client?.prenom, client?.nom].filter(Boolean).join(" ").trim();
    },
    setClientsState(clients = []) {
      this.clientData = [];
      this.clientIds = [];

      clients.forEach((client) => {
        this.clientData.push(this.getClientDisplayName(client));
        this.clientIds.push(client.id);
      });

      try {
        localStorage.setItem("clients", JSON.stringify(clients));
      } catch (_) {
        // Ignore storage errors.
      }
    },
    resetQuickClientForm() {
      this.quickClientForm = getEmptyQuickClientForm();
      this.quickClientErrors = {};
      this.quickClientSubmitting = false;
    },
    clearQuickClientError(field) {
      if (!this.quickClientErrors[field]) {
        return;
      }

      const nextErrors = { ...this.quickClientErrors };
      delete nextErrors[field];
      this.quickClientErrors = nextErrors;
    },
    toggleQuickClientForm() {
      this.showQuickClientForm = !this.showQuickClientForm;

      if (!this.showQuickClientForm) {
        this.resetQuickClientForm();
      }
    },
    cancelQuickClientForm() {
      this.showQuickClientForm = false;
      this.resetQuickClientForm();
    },
    validateQuickClientForm() {
      const errors = {};
      const email = String(this.quickClientForm.email ?? "").trim();

      if (!String(this.quickClientForm.nom ?? "").trim()) {
        errors.nom = "Le nom est obligatoire.";
      }

      if (!String(this.quickClientForm.prenom ?? "").trim()) {
        errors.prenom = "Le prénom est obligatoire.";
      }

      if (!String(this.quickClientForm.telephone ?? "").trim()) {
        errors.telephone = "Le téléphone est obligatoire.";
      }

      if (!String(this.quickClientForm.adresse ?? "").trim()) {
        errors.adresse = "L'adresse est obligatoire.";
      }

      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors.email = "Email invalide.";
      }

      if (this.quickClientForm.typeLabel === "Professionnel") {
        if (!String(this.quickClientForm.nom_societe ?? "").trim()) {
          errors.nom_societe = "Le nom de société est obligatoire.";
        }

        if (!String(this.quickClientForm.rc ?? "").trim()) {
          errors.rc = "Le RC est obligatoire.";
        }
      }

      this.quickClientErrors = errors;
      return Object.keys(errors).length === 0;
    },
    getBackendValidationErrors(error) {
      const rawErrors = error?.response?.data?.errors;

      if (!rawErrors || typeof rawErrors !== "object") {
        return {};
      }

      return Object.entries(rawErrors).reduce((accumulator, [field, messages]) => {
        accumulator[field] = Array.isArray(messages) ? messages[0] : messages;
        return accumulator;
      }, {});
    },
    getErrorMessage(error) {
      const data = error?.response?.data;

      if (!data) {
        return error?.message || "Une erreur est survenue";
      }

      if (data.errors && typeof data.errors === "object") {
        const firstKey = Object.keys(data.errors)[0];
        const firstValue = data.errors[firstKey];

        if (Array.isArray(firstValue) && firstValue.length) {
          return firstValue[0];
        }

        if (typeof firstValue === "string") {
          return firstValue;
        }
      }

      return data.error || data.message || "Une erreur est survenue";
    },
    async createQuickClientAndSelect() {
      if (this.quickClientSubmitting) {
        return;
      }

      if (!this.validateQuickClientForm()) {
        toast.error("Veuillez corriger les champs du client.");
        return;
      }

      this.quickClientSubmitting = true;
      this.quickClientErrors = {};

      try {
        const payload = {
          adresse: String(this.quickClientForm.adresse ?? "").trim(),
          informations_complementaires: String(
            this.quickClientForm.informations_complementaires ?? ""
          ).trim(),
          ville: String(this.quickClientForm.ville ?? "").trim(),
          pays: String(this.quickClientForm.pays ?? "Maroc").trim() || "Maroc",
          civilite: this.quickClientForm.civilite || null,
          nom: String(this.quickClientForm.nom ?? "").trim(),
          prenom: String(this.quickClientForm.prenom ?? "").trim(),
          cin: null,
          email: String(this.quickClientForm.email ?? "").trim() || null,
          telephone: String(this.quickClientForm.telephone ?? "").trim(),
          type:
            this.quickClientForm.typeLabel === "Professionnel"
              ? "COMPANY"
              : "INDIVIDUAL",
          type_client: "CLIENT",
          plafond_credit: this.quickClientForm.plafond_credit,
          delai_paiement: this.quickClientForm.delai_paiement,
          nom_societe:
            this.quickClientForm.typeLabel === "Professionnel"
              ? String(this.quickClientForm.nom_societe ?? "").trim()
              : null,
          rc:
            this.quickClientForm.typeLabel === "Professionnel"
              ? String(this.quickClientForm.rc ?? "").trim()
              : null,
          tp: String(this.quickClientForm.tp ?? "").trim() || null,
          ice: String(this.quickClientForm.ice ?? "").trim() || null,
          identifiant_fiscal:
            String(this.quickClientForm.identifiant_fiscal ?? "").trim() || null,
        };

        const client = await createClient(payload);
        await this.getClientsData();

        const displayName = this.getClientDisplayName(client);
        this.form.nom_client = displayName;
        this.form.client_id = client?.id ?? null;

        this.showQuickClientForm = false;
        this.resetQuickClientForm();
        toast.success("Client ajouté et sélectionné.");
      } catch (error) {
        console.error(error);
        this.quickClientErrors = this.getBackendValidationErrors(error);
        toast.error(this.getErrorMessage(error));
      } finally {
        this.quickClientSubmitting = false;
      }
    },
    async loadCommandeLines(commandeId) {
      if (!commandeId) {
        this.selectedProducts1 = [];
        this.deletedProducts1 = [];
        this.isCommandeLinesLoading = false;
        return [];
      }

      const now = Date.now();
      const cached = commandeLinesCache.get(commandeId);
      if (cached && now - cached.timestamp < COMMAND_LINES_CACHE_TTL_MS) {
        this.applyCommandeLines(cached.data);
        this.isCommandeLinesLoading = false;
        return cached.data;
      }

      this.isCommandeLinesLoading = true;

      if (activeCommandeLinesFetch && activeCommandeLinesId === commandeId) {
        try {
          const data = await activeCommandeLinesFetch;
          this.applyCommandeLines(data);
          return data;
        } catch (_) {
          return [];
        } finally {
          this.isCommandeLinesLoading = false;
        }
      }

      const fetchPromise = (async () => {
        try {
          const data = await getLignesCommandeDataByCommandeId(commandeId);
          commandeLinesCache.set(commandeId, {
            data,
            timestamp: Date.now(),
          });
          return data;
        } catch (error) {
          const status = error?.response?.status;
          if (status === 429) {
            toast.error("Trop de requêtes reçues. Merci de patienter quelques secondes.");
          } else {
            const message =
              error?.response?.data?.message ||
              error?.message ||
              "Impossible de récupérer les lignes de commande.";
            toast.error(message);
          }
          throw error;
        }
      })();

      activeCommandeLinesId = commandeId;
      activeCommandeLinesFetch = fetchPromise;

      try {
        const data = await fetchPromise;
        this.applyCommandeLines(data);
        return data;
      } finally {
        activeCommandeLinesFetch = null;
        activeCommandeLinesId = null;
        this.isCommandeLinesLoading = false;
      }
    },
    applyCommandeLines(data) {
      const mapped = Array.isArray(data)
        ? data.map((m) => {
          const montantHT = parseFloat(m.montant_HT) || 0;
          const montantTTC = parseFloat(m.montant_TTC) || 0;
          const rate = montantHT > 0 ? ((montantTTC / montantHT - 1) * 100) : 0;

          return {
            id: m.id,
            quantite: m.quantite,
            prix_unitaire: m.prix_unitaire,
            reduc: Number(m.reduction ?? 0),
            montant_HT: montantHT,
            montant_TTC: montantTTC,
            item_type: m.item_type, // keep ENUM value,
            item_type1: m.item_type,
            item_id: m.item_id,
            nom: m.item_data ? m.item_data.nom : m.nom_libre,
            tax: Number(rate.toFixed(2)) || 0,
            societe_id: m.societe_id,
          };
        })
        : [];

      this.selectedProducts1 = mapped;
      this.deletedProducts1 = [];
      if (this.form1) {
        this.recalculateTotals(this.selectedProducts1, this.form1);
      }
    },
    changePrice(index, list, form) {
      this.recalculateLine(list[index]);
      this.recalculateTotals(list, form);
    },
    increaseQuantity(index, list, form) {
      if (list[index].quantite !== undefined) {
        list[index].quantite++;
        this.recalculateLine(list[index]);
        this.recalculateTotals(list, form);
      }
    },
    decreaseQuantity(index, list, form) {
      if (list[index].quantite !== undefined && list[index].quantite > 1) {
        list[index].quantite--;
        this.recalculateLine(list[index]);
        this.recalculateTotals(list, form);
      }
    },
    normalizeTax(value) {
      if (value === null || value === undefined) return 0;
      const n = Number(String(value).replace(',', '.'));
      return isNaN(n) ? 0 : n;
    },
    normalizePercent(value) {
      if (value === null || value === undefined) return 0;
      const n = Number(String(value).replace(',', '.'));
      if (isNaN(n)) return 0;
      if (n < 0) return 0;
      if (n > 100) return 100;
      return n;
    },
    recalculateLine(line) {
      const qty = Number(line.quantite) || 0;
      const unit = Number(line.prix_unitaire) || 0;
      const rate = this.normalizeTax(line.tax);
      const reduc = this.normalizePercent(line.reduc);
      const netUnit = unit * (1 - reduc / 100);
      line.montant_HT = netUnit * qty;
      line.montant_TTC = line.montant_HT * (rate / 100) + line.montant_HT;
    },
    recalculateTotals(list, form) {
      form.montant_HT = 0;
      form.montant_TTC = 0;
      list.forEach((product) => {
        form.montant_HT += Number(product.montant_HT) || 0;
        form.montant_TTC += Number(product.montant_TTC) || 0;
      });
    },
    deleteProduct(index, list, form, deleted) {
      const removed = list.splice(index, 1);
      if (removed.length) deleted.push(removed[0]);
      this.recalculateTotals(list, form);
    },
    showConfirmation() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            confirmButtonClass: "btn btn-success",
          });
        }
      });
    },
    async getClientsData() {
      try {
        const data = await getClientsData();
        this.setClientsState(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error(error);
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Une erreur est survenue";
        toast.error(msg);
      }
    },
    getClientID(option) {
      let index = this.clientData.indexOf(option);
      if (index != -1) {
        return this.clientIds[index];
      }
      return index;
    },
    getClientName(id) {
      let index = this.clientIds.indexOf(id);
      if (index != -1) {
        return this.clientData[index];
      }
      return index;
    },
    async getProductsData() {
      this.productsData = [];
      this.productsIds = [];
      if (localStorage.getItem("products") != null) {
        const data = JSON.parse(localStorage.getItem("products"));
        data.map((m) => {
          m.item_type = "product";
          this.productsData.push(m.nom);
          this.productsIds.push(m);
        });
      } else {
        try {
          const data = await getProductsDataInStock();
          data.map((m) => {
            m.item_type = "product";
            this.productsData.push(m.nom);
            this.productsIds.push(m);
          });
        } catch (error) {
          console.error(error);
          const msg =
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message ||
            "Une erreur est survenue";
          toast.error(msg);
        }
      }

      if (localStorage.getItem("services") != null) {
        const data = JSON.parse(localStorage.getItem("services"));
        data.map((m) => {
          m.item_type = "service";
          this.productsData.push(m.nom);
          this.productsIds.push(m);
        });
      } else {
        try {
          const data = await getServicesData();
          data.map((m) => {
            m.item_type = "service";
            this.productsData.push(m.nom);
            this.productsIds.push(m);
          });
        } catch (error) {
          console.error(error);
          const msg =
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message ||
            "Une erreur est survenue";
          toast.error(msg);
        }
      }
      this.itemsList = this.productsIds
        .filter((product) => product.item_type === "product")
        .map((product) => product.nom);
    },
    getProductsID(option) {
      let index = this.productsData.indexOf(option);
      if (index != -1) {
        return this.productsIds[index];
      }
      return {};
    },
    getProductName(option) {
      let product = productsIds.find((m) => m.id === option);
      let index = this.productsIds.indexOf(product);
      if (index != -1) {
        return this.productsData[index];
      }
      return {};
    },
    addProduct(list, form) {
      const item = this.getProductsID(form.selectedProduct);
      const currentType =
        form === this.form ? this.selectedTypeAdd : this.selectedTypeEdit;

      // MANUAL PRODUCT
      if (!item || !item.id) {
        list.push({
          id: null,
          quantite: 1,
          prix_unitaire: 0,
          reduc: 0,
          montant_HT: 0,
          montant_TTC: 0,
          item_type: currentType,
          item_type1: currentType,
          item_id: null,
          nom: "",
          tax: 0,
          societe_id: this.form.societe_id,
        });
      }
      // DB PRODUCT / SERVICE
      else {
        const quantite = 1;
        const rate = this.normalizeTax(
          item.item_type === "product" ? item.taux_tva : item.taux_taxe
        );
        const montant_HT = item.prix_vente * quantite;
        const montant_TTC = montant_HT + montant_HT * (rate / 100);

        list.push({
          id: null,
          quantite,
          prix_unitaire: item.prix_vente,
          reduc: 0,
          montant_HT,
          montant_TTC,
          item_type: item.item_type === "product" ? "PRODUIT" : "SERVICE",
          item_type1: item.item_type === "product" ? "PRODUIT" : "SERVICE",
          item_id: item.id,
          nom: item.nom,
          tax: rate,
          societe_id: item.societe_id,
        });
      }

      this.recalculateTotals(list, form);
      form.selectedProduct = "";
    }
    ,
    async submitForm() {
      try {
        let user = decodeToken(localStorage.getItem("access_token"));
        this.form.societe_id = user.societe_id;
        this.form.cree_par = user.user_id;
        this.form.client_id = this.getClientID(this.form.nom_client);

        if (!this.form.nom_client || this.form.client_id === -1) {
          toast.error("Veuillez sélectionner un client.");
          return;
        }

        const response = await createCommand({
          date_creation: this.formatSQLDate(this.form.date_creation),
          statut: this.form.statut,
          mode_paiement: this.form.mode_paiement,
          conditions_paiement: this.form.conditions_paiement,
          date_livraison: this.formatSQLDate(
            this.calculateDeliveryDate(
              this.form.date_creation,
              this.form.delaiLivraision
            )
          ),
          client_id: this.form.client_id,
          montant_total: this.form.montant_TTC,
          montant_taxe: this.form.montant_TTC - this.form.montant_HT,

          notes: this.form.notes,
          cree_par: this.form.cree_par,
          societe_id: this.form.societe_id,
        });
        if (response !== null) {
          const commande_id = response.id;
          for (const product of selectedProducts) {
            await createCommandLine({
              quantite: product.quantite,
              prix_unitaire: product.prix_unitaire,
              montant_HT: product.montant_HT,
              montant_TTC: product.montant_TTC,
              commande_id: commande_id,
              item_type: product.item_type.toUpperCase(),
              item_id: product.item_id === null ? null : product.item_id,
              reduction: product.reduc ?? 0,
              nom_libre: product.item_id === null ? product.nom : null,
              societe_id: this.form.societe_id,
            });
          }

          commandeLinesCache.delete(commande_id);
          const response1 = await createDevis({
            date_creation: this.formatSQLDate(this.form.date_creation),
            statut: this.form.statut1,
            commande_id: commande_id,
            valide_jusqua: this.resolveDevisValidityDate(
              this.form.date_creation,
              this.form.conditions_paiement
            ),
            notes: this.form.notes,
            societe_id: this.form.societe_id,
          });
          this.$emit("devis-added", response1);
          const modalElement = document.getElementById("add-sales-new");
          const modal =
            Modal.getInstance(modalElement) || new Modal(modalElement);
          modal.hide();
        }
      } catch (error) {
        console.error(error);
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Une erreur est survenue";
        toast.error(msg);
      }
    },
    async submitForm1() {
      try {
        const commandeSnapshot = this._editCommandeSnapshot || {};

        await updateCommand(this.form1.commande_id, {
          date_creation: this.formatSQLDate(
            commandeSnapshot.date_creation || new Date()
          ),
          statut: commandeSnapshot.statut || "TERMINEE",
          mode_paiement: this.form1.mode_paiement,
          conditions_paiement: this.form1.conditions_paiement,
          date_livraison: this.formatSQLDate(
            this._editDeliveryChanged
              ? this.calculateDeliveryDate(
                  commandeSnapshot.date_creation || new Date(),
                  this.form1.delaiLivraision
                )
              : commandeSnapshot.date_livraison
          ),
          client_id: this.form1.client_id,
          montant_total: this.form1.montant_TTC,
          montant_taxe: this.form1.montant_TTC - this.form1.montant_HT,
          notes: this.form1.notes,
          cree_par: commandeSnapshot.cree_par,
          societe_id: this.form1.societe_id,
        });
        for (const product of this.selectedProducts1) {
          if (product.id !== null) {
            console.log(product.nom);
            

            await updateCommandLine(product.id, {
              quantite: product.quantite,
              prix_unitaire: product.prix_unitaire,
              montant_HT: product.montant_HT,
              montant_TTC: product.montant_TTC,
              commande_id: this.form1.commande_id,
              item_type: product.item_type.toUpperCase(),
              item_id: product.item_id === null ? null : product.item_id,
              societe_id: this.form1.societe_id,
              reduction: product.reduc ?? 0,
              nom_libre: product.item_id === null ? product.nom : null,
            });
          } else {
            await createCommandLine({
              quantite: product.quantite,
              prix_unitaire: product.prix_unitaire,
              montant_HT: product.montant_HT,
              montant_TTC: product.montant_TTC,
              commande_id: this.form1.commande_id,
              item_type: product.item_type.toUpperCase(),
              item_id: product.item_id === null ? null : product.item_id,
              reduction: product.reduc ?? 0,
              nom_libre: product.item_id === null ? product.nom : null,
              societe_id: this.form1.societe_id,
            });
          }
        }
        for (const product of this.deletedProducts1) {
          if (product.id !== null) {
            await deleteCommandLine(product.id, this.form1.commande_id);
          }
        }

        commandeLinesCache.delete(this.form1.commande_id);
        const response1 = await updateDevis(this.form1.devis_id, {
          date_creation: this.formatSQLDate(
            commandeSnapshot.date_creation || new Date()
          ),
          statut: this.form1.statut1,
          commande_id: this.form1.commande_id,
          valide_jusqua: this.resolveDevisValidityDate(
            commandeSnapshot.date_creation || new Date(),
            this.form1.conditions_paiement
          ),
          notes: this.form1.notes,
          societe_id: this.form1.societe_id,
        });
        this.$emit("edit-added", response1);
        this.closeEditModal();
      } catch (error) {
        console.error(error);
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Une erreur est survenue";
        toast.error(msg);
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    formatDateForInput(dateString) {
      const date = new Date(dateString);
      if (isNaN(date)) return "";
      return date.toISOString().split("T")[0];
    },
    parseDeliveryDelayDays(value) {
      const text = String(value || "").trim();

      if (!text) {
        return 0;
      }

      if (/imm[ée]diate/i.test(text)) {
        return 0;
      }

      const parenthesizedMatch = text.match(/\((\d+)\s*jours?\)/i);
      if (parenthesizedMatch) {
        return Number(parenthesizedMatch[1]) || 0;
      }

      const daysMatch = text.match(/(\d+)\s*jours?/i);
      if (daysMatch) {
        return Number(daysMatch[1]) || 0;
      }

      return 0;
    },
    calculateDeliveryDate(dateCreation, delay) {
      const baseDate = new Date(dateCreation || new Date());
      if (Number.isNaN(baseDate.getTime())) {
        return null;
      }

      const deliveryDate = new Date(baseDate);
      deliveryDate.setDate(
        deliveryDate.getDate() + this.parseDeliveryDelayDays(delay)
      );
      return this.dateOnly(deliveryDate);
    },
    dateOnly(value) {
      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) return "";
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    getDeliveryOptionFromDates(dateCreation, deliveryDate) {
      const createdAt = new Date(dateCreation || new Date());
      const deliveredAt = new Date(deliveryDate);

      if (Number.isNaN(createdAt.getTime()) || Number.isNaN(deliveredAt.getTime())) {
        return "Immédiate (0 jour)";
      }

      const createdDay = new Date(
        createdAt.getFullYear(),
        createdAt.getMonth(),
        createdAt.getDate()
      );
      const deliveredDay = new Date(
        deliveredAt.getFullYear(),
        deliveredAt.getMonth(),
        deliveredAt.getDate()
      );
      const diffDays = Math.max(
        Math.round((deliveredDay - createdDay) / (1000 * 60 * 60 * 24)),
        0
      );

      return (
        this.delaisOptions.find(
          (option) => this.parseDeliveryDelayDays(option) === diffDays
        ) || "Immédiate (0 jour)"
      );
    },
    formatSQLDate(value) {
      try {
        const d = value instanceof Date ? value : new Date(value);
        if (isNaN(d)) return null;
        return d.toISOString().slice(0, 19).replace("T", " ");
      } catch (_) {
        return null;
      }
    },
  },
  mounted() {
    this.getClientsData();
    this.getProductsData();
  },
  beforeUnmount() {
    if (activeCommandeLinesId && activeCommandeLinesFetch) {
      activeCommandeLinesFetch = null;
      activeCommandeLinesId = null;
    }
    Object.values(this.$refs)
      .filter((refEl) => refEl && typeof refEl.destroy === "function")
      .forEach((refEl) => {
        try {
          refEl.destroy();
        } catch (error) {
          console.error('Error loading cached commande lines:', error);
          return [];
        }
      });
  },
  watch: {
    selectedTypeAdd(value) {
      if (!value) return;
      const type = value === "PRODUIT" ? "product" : "service";
      this.itemsList = this.productsIds
        .filter(p => p.item_type === type)
        .map(p => p.nom);
    },

  },
};
</script>

<style scoped>
.devis-edit-overlay {
  position: fixed;
  inset: 0;
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 28px;
  background: rgba(15, 23, 42, 0.58);
  backdrop-filter: blur(2px);
}

.devis-edit-dialog {
  width: calc(100vw - 56px) !important;
  max-width: 1280px !important;
  max-height: calc(100vh - 56px);
  margin: 0 !important;
}

.devis-edit-dialog .modal-content {
  max-height: calc(100vh - 56px);
  overflow: hidden;
  background: #fff;
  border: 0;
  border-radius: 16px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.28);
}

.devis-edit-dialog .page-wrapper,
.devis-edit-dialog .content {
  position: static !important;
  width: 100% !important;
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  background: #fff;
}

.devis-edit-dialog .page-header {
  position: sticky;
  top: 0;
  z-index: 3;
  min-height: 76px;
  margin: 0 !important;
  padding: 20px 26px !important;
  background: #fff;
  border-bottom: 1px solid #e8edf4;
}

.devis-edit-dialog .page-header h4 {
  margin: 0;
  color: #102a4c;
  font-size: 22px;
}

.devis-edit-dialog .page-header .close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  color: #52637a;
  background: #f3f6fa;
  border: 0;
  border-radius: 10px;
  font-size: 26px;
}

.devis-edit-dialog .card {
  max-height: calc(100vh - 132px);
  margin: 0;
  overflow-y: auto;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.devis-edit-dialog .card-body {
  padding: 26px;
}

.devis-edit-dialog .input-blocks {
  margin-bottom: 20px;
}

.devis-edit-dialog .form-select,
.devis-edit-dialog .form-control,
.devis-edit-dialog input,
.devis-edit-dialog textarea {
  border-color: #dce4ef;
  border-radius: 9px;
}

.devis-edit-dialog .table-responsive {
  margin-top: 8px;
  border: 1px solid #e8edf4;
  border-radius: 12px;
}

.devis-edit-dialog .table {
  min-width: 980px;
  margin-bottom: 0;
}

.devis-edit-dialog .table thead th {
  padding: 14px 12px;
  white-space: nowrap;
  background: #f7f9fc;
}

.devis-edit-dialog .table tbody td {
  padding: 14px 12px;
  vertical-align: middle;
}

.devis-edit-dialog .total-order {
  margin-top: 22px !important;
  overflow: hidden;
  border: 1px solid #e8edf4;
  border-radius: 12px;
}

.devis-edit-dialog .total-order li {
  margin: 0;
  padding: 12px 16px;
}

.devis-edit-dialog textarea.form-control {
  min-height: 110px;
}

@media (max-width: 767px) {
  .devis-edit-overlay {
    align-items: flex-start;
    padding: 10px;
  }

  .devis-edit-dialog {
    width: 100% !important;
    max-height: calc(100vh - 20px);
  }

  .devis-edit-dialog .modal-content {
    max-height: calc(100vh - 20px);
    border-radius: 12px;
  }

  .devis-edit-dialog .page-header {
    min-height: 64px;
    padding: 14px 16px !important;
  }

  .devis-edit-dialog .card {
    max-height: calc(100vh - 84px);
  }

  .devis-edit-dialog .card-body {
    padding: 16px;
  }
}
</style>
